import Gobalstore from "../index";
import router from "../../router";
export const actions = {
  /* Category */
  getEntreatyProc: function (localStore) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "GET",
        url: `/business/guarded/entreaty/process`,
      })
        .then(function (response) {
          localStore.commit("setEntreatyProc", response.data);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  getEntreatyDetail: function (localStore, entId) {
    Gobalstore.commit("LoadingOverlay", true);
    localStore.state.ent_detail = {
      categories: [],
    };
    return new Promise((resolve, reject) => {
      this.axios({
        method: "GET",
        url: `/business/guarded/entreaty/${entId}`,
      })
        .then(function (response) {
          localStore.commit("setEntreatyDetail", response.ents);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((error) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(error);
        });
    });
  },

  createEntreaty: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    const body = localStore.state.ent_application;
    var that = this;
    return this.axios({
      method: "POST",
      url: "/business/guarded/entreaty/create",
      data: body,
      headers: payload.headers
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      localStore.state.ent_application = {};
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });

  },

  editEntreaty: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    const body = localStore.state.ent_application;
    var that = this;
    return this.axios({
      method: "POST",
      url: "/business/guarded/entreaty/edit/"+payload.ent_id,
      data: body,
      headers: payload.headers
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });

  },

  updateApplication: function (localStore) {
    this.axios({
      method: "POST",
      url: `/business/guarded/entreaty/application`,
      data: localStore.state.ent_application,
    }).then(function () {
      Gobalstore.commit("snackbarSuccess", true);
    });
  },

  updateAttorney: function (localStore) {
    this.axios({
      method: "POST",
      url: `/business/guarded/entreaty/attorney`,
      data: localStore.state.ent_attorney,
    }).then(function () {
      Gobalstore.commit("snackbarSuccess", true);
    });
  },

  uploadDocument: function (localStore, { formData, ent_id, doc_code }) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
        url: `/business/guarded/entreaty/upload/${ent_id}/${doc_code}`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });
  },

  viewDocument: function (localStore, { attach_id, }) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "GET",
        url: `/business/guarded/entreaty/view/${attach_id}`,
        responseType: "arraybuffer",
      })
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  },

  deleteDocument: function (localStore, { attach_id}) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "DELETE",
      url: `/business/guarded/entreaty/remove-doc/${attach_id}`,
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });
  },

   viewCertificate: function (localStore, { attach_id }) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "GET",
        url: `/business/guarded/entreaty/viewCertificate/${attach_id}`,
        responseType: "arraybuffer",
      })
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  },

  getTimeline: function (localStore, entId) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "GET",
      url: `/business/guarded/entreaty/timeline/${entId}`,
    })
      .then(function (response) {
        Gobalstore.commit("LoadingOverlay", false);
        return response;
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  submitEntreaty: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    
    return this.axios({
        method: "POST",
        url: `/business/guarded/entreaty/submit/`+payload.ent_id,
        headers: payload.headers
      })
      .then((response) => {
        Gobalstore.commit("LoadingOverlay", false);
        return response;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },

  getEntreatyPendingPayment: function (localStore) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "GET",
        url: `/business/guarded/entreaty/pendingpayment`,
      })
        .then(function (response) {
          localStore.commit("setEntreatyPaym", response.data);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  getEntreatyDone: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/business/guarded/entreaty/done`,
    })
      .then(function (response) {
        localStore.commit("setEntreatyDone", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  getDocTemplate: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/business/template`,
    })
      .then(function (response) {
        localStore.commit("setDocTemplate", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch((err) => {
        console.error(err);
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  downloadDocumentAtt: function (localStore, { file_name, urlname }) {
    this.axios({
      method: "GET",
      url: `/business/view${urlname}`,
      responseType: "arraybuffer",
    }).then(function (res) {
      var url = window.URL.createObjectURL(new Blob([res.data]));
      const filename = `${file_name}.${urlname.split(".")[1]}`;
      var link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    });
  },

  payment: function (localStore, invoice_id) {
  
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "PATCH",
      url: `/business/guarded/entreaty/genqr/${invoice_id}`,
    })
      .then(function (res) {
        Gobalstore.commit("LoadingOverlay", false);
        return res;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
    
  },

  paymentBillOrder: function (localStore, ent_id) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "POST",
        url: `/business/guarded/entreaty/payment-bill-order/${ent_id}`,
        responseType: "arraybuffer",
      })
        .then(function (res) {
          Gobalstore.commit("LoadingOverlay", false);
          var url = window.URL.createObjectURL(new Blob([res.data]));
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Bill-${ent_id}.pdf`);
          document.body.appendChild(link);
          link.click();
          resolve(res);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  getTINDetail: function (localStore, tin) {
    let value = tin?.toString().replace("-", "");
   
    return this.axios({
      method: "GET",
      url: `/business/tin-details/${value}`,
    })
    .then((res) => {
      if (res.data == null) {
        Gobalstore.commit("snackbarFailed", {
          value: true,
          msg: "ລະຫັດ TIN ບໍ່ຖືກຕ້ອງ",
        });
      } else {
        localStore.state.ent_application["tin_org_cd"] = res.data.data[0].org_cd;
        localStore.state.ent_application["tin"] = res.data.data[0].tin;
        localStore.state.ent_application["company_name_la"] =res.data.data[0].co_nm;
      }
      return res;
    })
    .catch((err) => {
      localStore.state.ent_application["tin_org_cd"] = "";
      localStore.state.ent_application["company_name_la"] = "";
      return err;
    });
    
  },

  findEnt: function (localStore, payload) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "POST",
        url: '/portal/find-ent',
        data: payload.query,
        headers: payload.headers
      })
        .then((res) => {
          localStore.commit("setEntFind", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteEntreaty: function (localStore, ent_id) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "DELETE",
        url: `/business/guarded/entreaty/disable/${ent_id}`,
      })
        .then(function (response) {
          localStore.commit("setEntreatyProc", response.data);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  getNotification: function (localStore) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "GET",
        url: `/business/guarded/notification`,
      })
        .then(function (response) {
          localStore.commit("setNotification", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  readNotification: function (localStore, payload) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "PATCH",
        url: `/business/guarded/notification`,
        data: payload,
      })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
